module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-panel__header"
  }, [_c('h2', [_vm._v(" New Session  ")])]), _vm._v(" "), _c('p', [_vm._v("Here we'll have a validated form to create new sessions (You'll have to wait for the next post)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-099141ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Session.vue
// module id = 103
// module chunks = 1